// extracted by mini-css-extract-plugin
export default {"parallaxContentContainer":"j_cW","title":"j_cX","popupsBlock":"j_cY","text":"j_cZ"};